"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var qs = require("qs");
var PatternUtils_1 = require("react-router/lib/PatternUtils");
var url_helpers_1 = require("./url_helpers");
var constants_1 = require("./constants");
function extractQueryParams(loc) {
    var _a;
    return qs.parse((_a = loc.search) === null || _a === void 0 ? void 0 : _a.slice(1));
}
var locationUtil = {
    isOnMarketplacePage: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match('/marketplace');
    },
    isOnBrandPage: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match('/brand/');
    },
    isOnSalePage: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match('/sales/');
    },
    isOnHandpickedPage: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match('/handpicked/');
    },
    isOnCompleteShopDetailsPage: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match(url_helpers_1.default.onboardingCompleteShopDetailsPath);
    },
    isOnBegin3DS1Page: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!loc.pathname.match(url_helpers_1.default.onboardingBegin3DS1);
    },
    isOnMatchingCms2Page: function (slug, loc) {
        if (loc === void 0) { loc = window.location; }
        return loc.pathname.includes(url_helpers_1.default.cms2PagePath(slug));
    },
    isFullyClientRenderedPage: function (path) {
        if (window.Reverb.noRouterContext) {
            return false;
        }
        return lodash_1.filter(constants_1.default.CLIENT_RENDERED_ROUTE_MATCHERS, function (matcher) { return path.match(matcher); }).length !== 0;
    },
    filteringShowOnlySold: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return !!extractQueryParams(loc).show_only_sold;
    },
    queryParams: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return extractQueryParams(loc);
    },
    pathname: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return loc.pathname;
    },
    reverbSearchParam: function () {
        var query = extractQueryParams(window.location).query;
        var value = query && query.split('=')[1] || '';
        return decodeURIComponent(value);
    },
    queryWithPage: function (queryObj, pageNum) {
        var newQuery = tslib_1.__assign({}, queryObj);
        if (pageNum === 1) {
            delete newQuery.page;
        }
        else {
            // important to stringify page # to ensure consistency with router params
            // otherwise, browser history will not work
            newQuery.page = pageNum.toString();
        }
        return newQuery;
    },
    currentPageWithParams: function (params, loc) {
        if (loc === void 0) { loc = window.location; }
        var currentQueryParams = extractQueryParams(loc);
        var newParams = qs.stringify(Object.assign(currentQueryParams, params));
        var searchString = newParams.length > 0 ? "?" + newParams : '';
        return "" + loc.origin + loc.pathname + searchString;
    },
    extractPathParams: function (paths, loc) {
        var nullMatch = { paramNames: null, paramValues: null };
        var _a = paths.reduce(function (extracted, path) {
            if (extracted.paramValues && extracted.paramValues.length) {
                return extracted;
            }
            return PatternUtils_1.matchPattern(path, loc.pathname) || nullMatch;
        }, nullMatch), paramNames = _a.paramNames, paramValues = _a.paramValues;
        var params = {};
        (paramNames || []).forEach(function (name, idx) {
            params[name] = paramValues[idx];
        });
        var query = extractQueryParams(loc);
        Object.assign(params, qs.parse(query));
        return params;
    },
    urlWithoutOrigin: function (loc) {
        if (loc === void 0) { loc = window.location; }
        return loc.href.replace(loc.origin, '');
    },
};
exports.default = locationUtil;
//# sourceMappingURL=location_util.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/shared/location_util.js
// module id = Lca4
// module chunks = 20 21